module.exports = __webpack_public_path__ + "static/img/ls14.4331c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls14.png
// module id = lS/4
// module chunks = 12